import { mastheadMeta } from "@/mocks/homeData";

export default function NewsTicker() {
  const line = [...mastheadMeta.ticker, ...mastheadMeta.ticker];

  return (
    <div className="border-b border-background-200/70 bg-background-100">
      <div className="flex items-center">
        <span className="flex shrink-0 items-center gap-1.5 bg-primary-500 px-3 py-2.5 font-label text-xs font-medium text-background-50 md:px-4">
          <i className="ri-flashlight-fill text-sm" />
          实时爆料
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap py-2.5 pl-6">
            {line.map((item, idx) => (
              <span key={`${item}-${idx}`} className="font-label text-xs text-foreground-700 md:text-[13px]">
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}